// Cookie names for consent checking
const COOKIE_NAMES = {
  CONSENT_GIVEN: 'appotype_consent_given',
  ANALYTICS: 'appotype_cookie_analytics'
};

export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
};

export const hasAnalyticsConsent = (): boolean => {
  const consentGiven = getCookie(COOKIE_NAMES.CONSENT_GIVEN);
  const analyticsConsent = getCookie(COOKIE_NAMES.ANALYTICS);
  
  // If no consent has been given yet, don't enable analytics
  if (!consentGiven) {
    return false;
  }
  
  // Check if analytics is explicitly enabled
  return analyticsConsent === 'true';
};

export const waitForConsent = (): Promise<boolean> => {
  return new Promise((resolve) => {
    const checkConsent = () => {
      const consentGiven = getCookie(COOKIE_NAMES.CONSENT_GIVEN);
      if (consentGiven) {
        resolve(hasAnalyticsConsent());
      } else {
        // Check again after a short delay
        setTimeout(checkConsent, 100);
      }
    };
    checkConsent();
  });
}; 